import { Component, forwardRef } from "react";
import Loader from "../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import { withRouter } from "../../../../utils/withRouter";
import { connect } from "react-redux";
import HeaderWithLogo from "../../../../common_components/header_with_logo";
import AdminDrawer from "../../../../common_components/admin_module_drawer";
import Pagination from "../../../../utils/pagination";
import { downloadReport, loginUrl, priorityNoActionId, toastError, headers, toastSuccess, exhibitionActionId, exhibitorNameActionId } from "../../../../utils/constants";
import Modal from "react-modal";
import { data } from "jquery";
import { descriptionPreview_action } from "../../../../actions/description_action"
import { fill_action } from "../../../../actions/fillCombo_action"
import Accordion from '@mui/material/Accordion';
import { getExhibitorDetailsReport_action, getReceiptReport_action, getTaxInvoiceReport_action, getExhibitorFinalRankReport_action } from "../../../../actions/admin_module_action/report_action/report_action";
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExcelJS from 'exceljs';
import { axiosGet, axiosPost } from "../../../../react_axios/Axios";

class subReport1 extends Component {
    // intialize constructor
    constructor(props) {
        super(props)
        this.state = {
            reportName: '',
            reportID: '',

            isLoading: false,
            showTable: false,
            exhibitionID: '',
            exhibitionList: [],
            exhibitorList: [],
            list: [],
            columnArr: [],
            rowArr: [],
            ExhRegistrationID: '',
            xlrowArr: [],
            reportAccessList: []
        }

        this.onViewClick = this.onViewClick.bind(this)
        this.renderTable = this.renderTable.bind(this)
        this.onDownloadClick = this.onDownloadClick.bind(this)
        this.getFillList = this.getFillList.bind(this)
        this.getExhibitorDetailsReportlist = this.getExhibitorDetailsReportlist.bind(this)
        this.reportIdCondition = this.reportIdCondition.bind(this)
        this.getReceiptReportlist = this.getReceiptReportlist.bind(this)
        this.getTaxInvoiceReportlist = this.getTaxInvoiceReportlist.bind(this)
        this.getDownloadAccess = this.getDownloadAccess.bind(this)
        this.getViewAccess = this.getViewAccess.bind(this)
    }

    componentDidMount() {
        // this.getExhibitionManualForm()
        this.getFillList(exhibitionActionId, '', '', '', '', '')
        this.getFillList(exhibitorNameActionId, '', '', '', '', '')
        this.setState({
            reportName: this.props.location.state != null && this.props.location.state.reportName != null ? this.props.location.state.reportName : '',
            reportID: this.props.location.state != null && this.props.location.state.reportID != null ? this.props.location.state.reportID : '',
            reportAccessList: JSON.parse(sessionStorage.getItem('loginDataSS'))['reportAccesslist']
        })
        setTimeout(() => {
            console.log("BBBBBBBBBBBBBBBBBBBB", JSON.parse(sessionStorage.getItem('loginDataSS'))['reportAccesslist'])
            console.log(this.state.reportID)
        }, 100);
    }

    reportIdCondition(status, value) {
        const { reportID, reportName } = this.state
        if (reportName == 'Exhibitor Details Report') {
            this.getExhibitorDetailsReportlist(status, value)
        }
        if (reportName == 'Exhibitor Receipt Report') {
            this.getReceiptReportlist(status, value)
        }
        if (reportName == 'Exhibitor Invoice Report') {
            this.getTaxInvoiceReportlist(status, value)
        }
        if (reportName == 'Exhibitor Final Rank') {
            this.getExhibitorFinalRankReportlist(status, value)
        }
    }

    getExhibitorDetailsReportlist(status, value) {
        const { exhibitionID, ExhRegistrationID } = this.state
        console.log(status, value)
        if (status == 'exhibitionID') {
            this.setState({ exhibitionID: value })
            if (value != 'select') {
                this.setState({ isLoading: true })
                this.props.getExhibitorDetailsReport_action(parseInt(value), ExhRegistrationID == '' || ExhRegistrationID == null ? 0 : ExhRegistrationID)
                    .then((data) => {
                        console.log(data)
                        if (data.error != 1) {
                            // data.data.map((element) =>
                            //     delete element['ADDITIONAL BADGES'])
                            this.setState({ list: data.data })
                            // if (status == 'view') {
                            this.getTableData(data.data)
                            this.setState({ showTable: false })
                            // }
                            // else if (status == 'download') {
                            //     this.onDownloadClick(data.data)
                            //     this.setState({ isLoading: false })
                            this.setState({ isLoading: false })

                        }
                        else {
                            this.setState({ isLoading: false })
                            toastError(data.msg)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                        this.setState({ isLoading: false })
                    })

            }
            else {
                console.log(value)
                this.setState({ list: [], rowArr: [], columnArr: [], showTable: false })
            }
        }
        if (status == 'ExhRegistrationID') {
            console.log(exhibitionID)
            this.setState({ ExhRegistrationID: value })
            if (exhibitionID != null && exhibitionID != '' && exhibitionID != 'select') {
                this.setState({ isLoading: true })
                this.props.getExhibitorDetailsReport_action(exhibitionID, value == 'select' ? 0 : value)
                    .then((data) => {
                        console.log(data)
                        if (data.error != 1) {
                            // data.data.map((element) =>
                            //     delete element['ADDITIONAL BADGES'])
                            this.setState({ list: data.data })
                            // if (status == 'view') {
                            this.getTableData(data.data)
                            this.setState({ showTable: false })
                            // }
                            // else if (status == 'download') {
                            //     this.onDownloadClick(data.data)
                            //     this.setState({ isLoading: false })
                            // }
                            this.setState({ isLoading: false })

                        }
                        else {
                            this.setState({ isLoading: false })
                            toastError(data.msg)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                        this.setState({ isLoading: false })
                    })
            }
        }
        // if (exhibitionID = null || exhibitionID == '') {
        //     toastError("please select exhibition")
        // }
    }

    getReceiptReportlist(status, value) {
        const { exhibitionID, ExhRegistrationID } = this.state
        console.log(status, value)
        if (status == 'exhibitionID') {
            this.setState({ exhibitionID: value })
            if (value != 'select') {
                this.setState({ isLoading: true })
                this.props.getReceiptReport_action(parseInt(value), ExhRegistrationID == '' || ExhRegistrationID == null ? 0 : ExhRegistrationID)
                    .then((data) => {
                        console.log(data)
                        if (data.error != 1) {
                            // data.data.map((element) =>
                            //     delete element['ADDITIONAL BADGES'])
                            this.setState({ list: data.data })
                            // if (status == 'view') {
                            this.getTableData(data.data)
                            this.setState({ showTable: false })
                            // }
                            // else if (status == 'download') {
                            //     this.onDownloadClick(data.data)
                            //     this.setState({ isLoading: false })
                            this.setState({ isLoading: false })

                        }
                        else {
                            this.setState({ isLoading: false })
                            toastError(data.msg)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                        this.setState({ isLoading: false })
                    })

            }
            else {
                console.log(value)
                this.setState({ list: [], rowArr: [], columnArr: [], showTable: false })
            }
        }
        if (status == 'ExhRegistrationID') {
            console.log(exhibitionID)
            this.setState({ ExhRegistrationID: value })
            if (exhibitionID != null && exhibitionID != '' && exhibitionID != 'select') {
                this.setState({ isLoading: true })
                this.props.getReceiptReport_action(exhibitionID, value == 'select' ? 0 : value)
                    .then((data) => {
                        console.log(data)
                        if (data.error != 1) {
                            // data.data.map((element) =>
                            //     delete element['ADDITIONAL BADGES'])
                            this.setState({ list: data.data })
                            // if (status == 'view') {
                            this.getTableData(data.data)
                            this.setState({ showTable: false })
                            // }
                            // else if (status == 'download') {
                            //     this.onDownloadClick(data.data)
                            //     this.setState({ isLoading: false })
                            // }
                            this.setState({ isLoading: false })

                        }
                        else {
                            this.setState({ isLoading: false })
                            toastError(data.msg)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                        this.setState({ isLoading: false })
                    })
            }
        }
        // if (exhibitionID = null || exhibitionID == '') {
        //     toastError("please select exhibition")
        // }
    }

    getTaxInvoiceReportlist(status, value) {
        const { exhibitionID, ExhRegistrationID } = this.state
        console.log(status, value)
        if (status == 'exhibitionID') {
            this.setState({ exhibitionID: value })
            if (value != 'select') {
                this.setState({ isLoading: true })
                this.props.getTaxInvoiceReport_action(parseInt(value), ExhRegistrationID == '' || ExhRegistrationID == null ? 0 : ExhRegistrationID)
                    .then((data) => {
                        console.log(data)
                        if (data.error != 1) {
                            // data.data.map((element) =>
                            //     delete element['ADDITIONAL BADGES'])
                            this.setState({ list: data.data })
                            // if (status == 'view') {
                            this.getTableData(data.data)
                            this.setState({ showTable: false })
                            // }
                            // else if (status == 'download') {
                            //     this.onDownloadClick(data.data)
                            //     this.setState({ isLoading: false })
                            this.setState({ isLoading: false })

                        }
                        else {
                            this.setState({ isLoading: false })
                            toastError(data.msg)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                        this.setState({ isLoading: false })
                    })

            }
            else {
                console.log(value)
                this.setState({ list: [], rowArr: [], columnArr: [], showTable: false })
            }
        }
        if (status == 'ExhRegistrationID') {
            console.log(exhibitionID)
            this.setState({ ExhRegistrationID: value })
            if (exhibitionID != null && exhibitionID != '' && exhibitionID != 'select') {
                this.setState({ isLoading: true })
                this.props.getTaxInvoiceReport_action(exhibitionID, value == 'select' ? 0 : value)
                    .then((data) => {
                        console.log(data)
                        if (data.error != 1) {
                            // data.data.map((element) =>
                            //     delete element['ADDITIONAL BADGES'])
                            this.setState({ list: data.data })
                            // if (status == 'view') {
                            this.getTableData(data.data)
                            this.setState({ showTable: false })
                            // }
                            // else if (status == 'download') {
                            //     this.onDownloadClick(data.data)
                            //     this.setState({ isLoading: false })
                            // }
                            this.setState({ isLoading: false })

                        }
                        else {
                            this.setState({ isLoading: false })
                            toastError(data.msg)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                        this.setState({ isLoading: false })
                    })
            }
        }
        // if (exhibitionID = null || exhibitionID == '') {
        //     toastError("please select exhibition")
        // }
    }

    getExhibitorFinalRankReportlist(status, value) {
        const { exhibitionID, ExhRegistrationID } = this.state
        console.log(status, value)
        if (status == 'exhibitionID') {
            this.setState({ exhibitionID: value })
            if (value != 'select') {
                this.setState({ isLoading: true })
                this.props.getExhibitorFinalRankReport_action(parseInt(value), ExhRegistrationID == '' || ExhRegistrationID == null ? 0 : ExhRegistrationID)
                    .then((data) => {
                        console.log(data)
                        if (data.error != 1) {
                            this.setState({ list: data.data })
                            this.getTableData(data.data)
                            this.setState({ showTable: false })
                            this.setState({ isLoading: false })
                        }
                        else {
                            this.setState({ isLoading: false })
                            toastError(data.msg)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                        this.setState({ isLoading: false })
                    })
            }
            else {
                console.log(value)
                this.setState({ list: [], rowArr: [], columnArr: [], showTable: false })
            }
        }
        if (status == 'ExhRegistrationID') {
            console.log(exhibitionID)
            this.setState({ ExhRegistrationID: value })
            if (exhibitionID != null && exhibitionID != '' && exhibitionID != 'select') {
                this.setState({ isLoading: true })
                this.props.getExhibitorFinalRankReport_action(exhibitionID, value == 'select' ? 0 : value)
                    .then((data) => {
                        console.log(data)
                        if (data.error != 1) {
                            this.setState({ list: data.data })
                            this.getTableData(data.data)
                            this.setState({ showTable: false })
                            this.setState({ isLoading: false })
                        }
                        else {
                            this.setState({ isLoading: false })
                            toastError(data.msg)
                        }
                    })
                    .catch((err) => {
                        console.log(err)
                        this.setState({ isLoading: false })
                    })
            }
        }
    }

    // get Fill List
    getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
        const { } = this.state
        this.setState({ isLoading: true })
        this.props.fill_action(actionID, exhibitionID, moduleID, keyValue, value)
            .then((data) => {
                if (data.error != 1) {
                    // Country List
                    if (actionID === exhibitionActionId) {
                        console.log("country data", data.data)
                        this.setState({
                            exhibitionList: data.data,
                            isLoading: false
                        })
                    }
                    // visa  id type
                    if (actionID === exhibitorNameActionId) {
                        console.log("visaIdTypeActionId data", data.data)
                        this.setState({
                            exhibitorList: data.data,
                            isLoading: false
                        })
                    }
                }
                else {
                    this.setState({ isLoading: false })
                    toastError(data.msg)
                }
            })
            .catch((err) => {
                console.log(err)
                this.setState({ isLoading: false })
            })
    }

    onViewClick() {
        const { exhibitionID, ExhRegistrationID } = this.state
        console.log(this.state.list)
        if (exhibitionID == '' || exhibitionID == null || exhibitionID == 'select') {
            toastError('Please select exhibition ID')
        }
        else {
            this.setState({ showTable: true })
        }
    }

    getTableData(list) {
        const { } = this.state
        // for column data 
        var columnArray = []
        var rowData = []
        console.log('columnArray', list);

        list.map((data, index) => {
            if (index == 0) {
                console.log('columnArray', data, Object.keys);

                Object.keys(data).map((key, index) => {

                    columnArray.push(key)
                })
            }
        })
        this.setState({ columnArr: columnArray })
        console.log('columnArray', columnArray);
        var xlRowdata = []
        // // for row data
        list.map((data, index) => {
            rowData.push(Object.values(data))
            xlRowdata.push(data)
        })
        this.setState({ rowArr: rowData })
        this.setState({ xlrowArr: xlRowdata })
        setTimeout(() => {

            console.log(rowData, xlRowdata)
        }, 500);

        // this.renderTable()
        // if (listName == 'SLA_BreachList') {
        //     console.log("onReset 12", list)

        //     this.setState({
        //         SLA_BreachRowData: rowData,
        //         SLA_BreachColumnArray: columnArray,
        //         temp_SLA_BreachRowData: rowData,
        //     })
        //     columnArray = []
        //     rowData = []
        //     console.log("onReset 12 original_SLA_BreachRowData", original_SLA_BreachRowData)
        //     setTimeout(() => {
        //         this.getClientList()
        //     }, 300);
        // }
        // if (listName == 'original_SLA_BreachList') {
        //     console.log("onReset 12 original_SLA_BreachList", list)
        //     this.setState({
        //         original_SLA_BreachRowData: rowData,
        //         SLA_BreachRowData: rowData
        //     })
        //     columnArray = []
        //     rowData = []
        //     console.log("onReset 12 original_SLA_BreachRowData", original_SLA_BreachRowData)

        // }
    }

    onDownloadClick() {
        const { exhibitionID } = this.state
        if (exhibitionID == '' || exhibitionID == null || exhibitionID == 0) {
            toastError('Please select exhibition ID')
        }
        else {
            this.setState({ showTable: true })
            this.downloadExcel()
        }
    }

    getViewAccess() {
        const { reportAccessList, reportID } = this.state
        const moduleAccess = reportAccessList.find((item) => item.ReportID == reportID);
        if (moduleAccess) {
            return moduleAccess.ViewAccess;
        } else {
            return false
        }
        return false;
    }

    getDownloadAccess() {
        const { reportAccessList, reportID } = this.state
        const moduleAccess = reportAccessList.find((item) => item.ReportID == reportID);
        if (moduleAccess) {
            return moduleAccess.DownloadAccess;
        } else {
            return false
        }
        return false;
    }

    getFormattedDateTime() {
        const now = new Date();
        const day = String(now.getDate()).padStart(2, '0');
        const month = String(now.getMonth() + 1).padStart(2, '0');
        const year = now.getFullYear();
        const hours = String(now.getHours()).padStart(2, '0');
        return `${day}${month}${year} ${hours}pm`;
    }

    async downloadExcel() {
        const { xlrowArr, columnArr, reportName, list } = this.state;

        try {
            const workbook = new ExcelJS.Workbook();
            const isExhibitorFinalRank = reportName === 'Exhibitor Final Rank';

            const sheetName = isExhibitorFinalRank ? `Final Rank till ${this.getFormattedDateTime()}` : 'Sheet A';
            const sheet1 = workbook.addWorksheet(sheetName);

            const columnWidths1 = [15.6640625, 22.6640625, 71.6640625, 26.5546875, 15.77734375, 35.5546875, 36.21875, 36.44140625, 51.21875];

            // For Exhibitor Final Rank, use exact column names from reference file
            const sheet1Headers = isExhibitorFinalRank ? [
                'ExhRegistrationID',
                'Application Reference No.',
                'Company Name',
                'Chapter Name',
                'Application Status',
                '1st Rank\n(Basis of 1st installment Full Paid Receipt)',
                '2nd Rank\n(Basis of 2nd installment Full Paid Receipt)',
                'Final Rank\n(1st Installment weightage =60 & 2nd Installment weightage =40)\n((1st rank * 60/100)+ (2nd Rank * 40/100))',
                'Serialised Priority Number(Display in exhibitor\'s dashboard)'
            ] : columnArr;

            sheet1.columns = (isExhibitorFinalRank ? sheet1Headers : columnArr).map((col, index) => ({
                header: col,
                key: col,
                width: columnWidths1[index] || 18
            }));

            if (isExhibitorFinalRank) {
                const headerRow = sheet1.getRow(1);
                headerRow.height = 57.6;

                sheet1Headers.forEach((col, index) => {
                    const cell = headerRow.getCell(index + 1);
                    if (index < 5) {
                        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFB8CCE4' } };
                    } else {
                        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFC000' } };
                    }
                    cell.font = { size: 11, color: { argb: 'FF000000' } };
                    cell.alignment = { horizontal: 'center', vertical: 'center', wrapText: true };
                    cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                });

                xlrowArr.forEach((row, rowIndex) => {
                    const excelRow = sheet1.addRow(row);

                    // Map data to columns by index
                    sheet1Headers.forEach((header, colIndex) => {
                        const cell = excelRow.getCell(colIndex + 1);

                        // Try to find matching value in row
                        let value = '';
                        // First try exact match
                        if (row[header] !== undefined) {
                            value = row[header];
                        } else {
                            // Try to find by similar keys
                            const keys = Object.keys(row);
                            let matchingKey = null;

                            // Special handling for specific columns
                            if (header.includes('Serialised Priority Number')) {
                                matchingKey = keys.find(k =>
                                    k.toLowerCase().includes('serialised') ||
                                    k.toLowerCase().includes('priority') ||
                                    k === 'ITME2026/1' || // Example value pattern
                                    k.includes('ITME')
                                );
                            } else if (header.includes('1st Rank') && header.includes('Basis')) {
                                matchingKey = keys.find(k =>
                                    (k.includes('1st Rank') && k.includes('Basis')) ||
                                    k === '1st Rank' ||
                                    k.includes('installment')
                                );
                            } else if (header.includes('2nd Rank') && header.includes('Basis')) {
                                matchingKey = keys.find(k =>
                                    (k.includes('2nd Rank') && k.includes('Basis')) ||
                                    k === '2nd Rank'
                                );
                            } else if (header.includes('Final Rank') && header.includes('weightage')) {
                                matchingKey = keys.find(k =>
                                    (k.includes('Final Rank') && k.includes('weightage')) ||
                                    k === 'Final Rank'
                                );
                            } else {
                                // Generic matching for other columns
                                const headerBase = header.split('\n')[0].toLowerCase();
                                matchingKey = keys.find(k =>
                                    k.toLowerCase().includes(headerBase) ||
                                    headerBase.includes(k.toLowerCase())
                                );
                            }

                            if (matchingKey) {
                                value = row[matchingKey];
                            }
                        }

                        cell.value = value || '';
                        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } };
                        cell.font = { size: 11, color: { argb: 'FF000000' } };
                        cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                    });
                });
            } else {
                const headerRow = sheet1.getRow(1);
                headerRow.font = { bold: true, size: 11 };
                headerRow.alignment = { horizontal: 'center', vertical: 'center', wrapText: true };
                headerRow.eachCell(cell => {
                    cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                });

                xlrowArr.forEach((row, rowIndex) => {
                    sheet1.addRow(row);
                });
            }

            if (isExhibitorFinalRank) {
                const sheet2 = workbook.addWorksheet('Chapter wise ranking');
                const columnWidths2 = [15.6640625, 22.6640625, 56.33203125, 26.88671875, 15.6640625, 37.77734375, 32.77734375, 45.6640625, 49.6640625];

                const sheet2Headers = ['Sr No.', 'Application Reference No.', 'Company Name', 'Chapter Name', 'Application Status', '1st Rank\n(Basis of 1st installment Full Paid Receipt)', '2nd Rank\n(Basis of 2nd installment Full Paid Receipt)', 'Final Rank\n(1st Installment weightage =60 & 2nd Installment weightage =40)\n((1st rank * 60/100)+ (2nd Rank * 40/100))', 'Serialised Priority Number(Display in exhibitor\'s dashboard)'];

                sheet2.columns = sheet2Headers.map((col, index) => ({
                    header: col,
                    key: col,
                    width: columnWidths2[index] || 18
                }));

                const headerRow = sheet2.getRow(1);
                headerRow.height = 57.6;

                sheet2Headers.forEach((col, index) => {
                    const cell = headerRow.getCell(index + 1);
                    if (index < 5) {
                        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFB8CCE4' } };
                    } else {
                        cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFC000' } };
                    }
                    cell.font = { size: 11, color: { argb: 'FF000000' } };
                    cell.alignment = { horizontal: 'center', vertical: 'center', wrapText: true };
                    cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                });

                const groupedData = this.groupDataByChapter(xlrowArr);
                let dataRowIndex = 2;

                groupedData.forEach((row) => {
                    const isChapterHeader = row.isChapterHeader === true;
                    const isEmptyRow = row.isEmptyRow === true;

                    dataRowIndex++;

                    if (isEmptyRow) {
                        // Skip empty rows (they'll just be blank)
                        return;
                    }

                    if (isChapterHeader) {
                        const chapterRow = sheet2.getRow(dataRowIndex);
                        chapterRow.height = 35; // Increased height for chapter header

                        sheet2Headers.forEach((col, index) => {
                            const cell = chapterRow.getCell(index + 1);

                            if (index === 3) {
                                // Column D: Set chapter name value
                                cell.value = row[col] || row['Chapter Name'] || '';
                                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD9E1F2' } };
                                cell.font = { bold: true, size: 18, color: { argb: 'FF000000' } };
                                cell.alignment = { horizontal: 'center', vertical: 'center' };
                                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                            } else if (index === 4 || index === 5) {
                                // Columns E, F: Empty value but styled (for merge)
                                cell.value = '';
                                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFD9E1F2' } };
                                cell.font = { bold: true, size: 18, color: { argb: 'FF000000' } };
                                cell.alignment = { horizontal: 'center', vertical: 'center' };
                                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                            } else {
                                // Columns A, B, C: White/empty
                                cell.value = '';
                                cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } };
                                cell.font = { size: 11, color: { argb: 'FF000000' } };
                                cell.alignment = { horizontal: 'left', vertical: 'center' };
                                cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                            }
                        });

                        // Merge cells D:F for chapter header
                        sheet2.mergeCells(`D${dataRowIndex}:F${dataRowIndex}`);
                    } else {
                        const dataRow = sheet2.getRow(dataRowIndex);

                        sheet2Headers.forEach((col, index) => {
                            const cell = dataRow.getCell(index + 1);

                            // Try to find matching value in row
                            let value = '';
                            const keys = Object.keys(row);

                            // First try exact match
                            if (row[col] !== undefined && row[col] !== '') {
                                value = row[col];
                            } else {
                                // Try alternative key matching strategies
                                let matchingKey = null;

                                if (col === 'Sr No.') {
                                    matchingKey = keys.find(k => k === 'Sr No.' || k === 'Sr No' || k === 'srNo');
                                } else if (col === 'Application Reference No.') {
                                    matchingKey = keys.find(k => k === 'Application Reference No.' || k === 'Application Reference No');
                                } else if (col === 'Company Name') {
                                    matchingKey = keys.find(k => k === 'Company Name' || k === 'CompanyName');
                                } else if (col === 'Chapter Name') {
                                    matchingKey = keys.find(k => k === 'Chapter Name' || k === 'ChapterName');
                                } else if (col === 'Application Status') {
                                    matchingKey = keys.find(k => k === 'Application Status' || k === 'ApplicationStatus');
                                } else if (col.includes('Final Rank') && col.includes('weightage')) {
                                    // Check Final Rank first (before 2nd Rank) since Final Rank header contains "2nd Rank" text
                                    matchingKey = keys.find(k => k === 'Final Rank' || (k.includes('Final') && k.includes('Rank')));
                                } else if (col.includes('1st Rank')) {
                                    matchingKey = keys.find(k => k === '1st Rank' || (k.includes('1st') && k.includes('Rank') && !k.includes('2nd') && !k.includes('Final')));
                                } else if (col.includes('2nd Rank') && !col.includes('Final')) {
                                    matchingKey = keys.find(k => k === '2nd Rank' || (k.includes('2nd') && k.includes('Rank') && !k.includes('Final')));
                                } else if (col.includes('Serialised Priority Number')) {
                                    matchingKey = keys.find(k =>
                                        k === 'Serialised Priority Number' ||
                                        k === 'Serialised Priority Number(Display in exhibitor\'s dashboard)' ||
                                        k.toLowerCase().includes('serialised') ||
                                        k.toLowerCase().includes('priority')
                                    );
                                }

                                if (matchingKey) {
                                    value = row[matchingKey];
                                }
                            }

                            cell.value = value || '';
                            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFFFFF' } };
                            cell.font = { size: 11, color: { argb: 'FF000000' } };
                            cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
                        });
                    }
                });
            }

            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.download = `${reportName}.xlsx`;
            link.click();
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error generating Excel:', error);
            toastError('Error downloading report');
        }
    }

    groupDataByChapter(data) {
        const grouped = {};
        const chapterOrder = [];

        data.forEach((item) => {
            const chapter = item['Chapter Name'] || 'Others';
            if (!grouped[chapter]) {
                grouped[chapter] = [];
                chapterOrder.push(chapter);
            }
            grouped[chapter].push(item);
        });

        const groupedData = [];
        let isFirstChapter = true;

        chapterOrder.forEach((chapter) => {
            // Add empty row before chapter header (except before first chapter)
            if (!isFirstChapter) {
                groupedData.push({ isEmptyRow: true });
            }
            isFirstChapter = false;

            // Create chapter header row with chapter name only in column D (will be merged D:F)
            const chapterHeader = {
                'Sr No.': '',
                'Application Reference No.': '',
                'Company Name': '',
                'Chapter Name': chapter,
                'Application Status': '',
                '1st Rank\n(Basis of 1st installment Full Paid Receipt)': '',
                '2nd Rank\n(Basis of 2nd installment Full Paid Receipt)': '',
                'Final Rank\n(1st Installment weightage =60 & 2nd Installment weightage =40)\n((1st rank * 60/100)+ (2nd Rank * 40/100))': '',
                'Serialised Priority Number(Display in exhibitor\'s dashboard)': '',
                isChapterHeader: true
            };
            groupedData.push(chapterHeader);

            // Add empty row after chapter header
            groupedData.push({ isEmptyRow: true });

            // Reset serial number for each chapter
            let chapterSrNo = 1;

            // Add data rows with Sr No. (reset for each chapter)
            grouped[chapter].forEach((item) => {
                // Copy all original item properties to preserve data
                const newRow = { ...item, 'Sr No.': chapterSrNo };
                groupedData.push(newRow);
                chapterSrNo++;
            });
        });

        return groupedData;
    }


    renderTable() {
        const { columnArr, rowArr } = this.state
        console.log('k')
        return (
            <>
                <div className="table-responsive mb-4">
                    <table className="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                        <thead> <tr>
                            {/* <th><input type="checkbox" key={Math.random()} defaultChecked={isAllCheck} onClick={() => this.allCheckClick(!isAllCheck)} /></th> */}
                            {
                                columnArr.length > 0 && columnArr.map((data, index) => (
                                    <>  {(<th>{data}</th>)}</>
                                ))
                            }    </tr>

                        </thead>

                        <tbody>
                            {
                                rowArr.length > 0 ?
                                    rowArr.map((data, i) => (
                                        <tr key={i}>
                                            {/* <td><input type="checkbox" key={Math.random()} defaultChecked={data[data.length - 1]} onClick={() => this.onSelectCheckClick(data[data.length - 2], !data[data.length - 1])} /></td> */}
                                            {data != null && data != '' && data.map((element, index) => (
                                                <>
                                                    <td>{element}
                                                    </td></>

                                            ))}
                                        </tr>
                                    )) : <tr><td colSpan={3} style={{ textAlign: 'center' }}>Record not found</td></tr>
                            }
                        </tbody>
                    </table>
                </div>
            </>
        )
    }

    render() {
        const { isLoading, reportID, reportName, rowArr, exhibitorList, showTable, exhibitionID, ExhRegistrationID, exhibitionList, xlrowArr, columnArr, list } = this.state
        return (
            <>
                {isLoading ? (
                    <Loader></Loader>
                ) : (
                    null
                )}
                <ToastContainer />
                <HeaderWithLogo />
                <div className={JSON.parse(sessionStorage.getItem('loginDataSS')).RoleID == 1 ? "with-dr-container" : "with-dr-container com-height"} style={{ marginTop: '5rem', color: 'white' }}>
                    <AdminDrawer />
                    <div className="row">
                        <div className="step-name-space" style={{ zIndex: 9 }}>
                            <p>{reportName}</p>
                        </div>
                    </div>

                    <div className="main-container" >
                        <div className="row mt-5 m-2">
                            <div className="col-xl-3">
                                <label class="text-dark">Select Exhibition <span className="text-red">*</span></label>
                                <select className="form-control"
                                    value={exhibitionID}
                                    // disabled={isView}
                                    onChange={(e) => this.reportIdCondition("exhibitionID", e.target.value != '' && e.target.value)}  >
                                    <option value={'select'}>Select</option>
                                    {
                                        exhibitionList.length > 0 && exhibitionList.map(data => (
                                            <option value={data.ExhibitionID} key={data.ExhibitionID}>{data.ExhibitionName}</option>
                                        ))
                                    }
                                </select>
                            </div>
                            <div className="col-xl-3">
                                <label class="text-dark">Select Exhibitor company</label>
                                <select className="form-control"
                                    value={ExhRegistrationID}
                                    // disabled={isView}
                                    onChange={(e) => this.reportIdCondition('ExhRegistrationID', e.target.value != '' && e.target.value)}  >
                                    <option value={'select'}>Select</option>
                                    <option value={0}>All</option>

                                    {
                                        exhibitorList.length > 0 && exhibitorList.map(data => (
                                            <option value={data.ExhRegistrationID} key={data.ExhRegistrationID}>{data.CompanyName}</option>
                                        ))
                                    }
                                </select>
                            </div>

                            <div className="btn-group mt-4 save-can d-block" style={{ float: 'right', right: '0px' }} role="group" aria-label="Basic example">
                                <button
                                    type="button"
                                    className="btn btn-aqua p-1 m-2"
                                    style={{ width: 140, fontSize: 15, }}
                                    disabled={!this.getViewAccess()}
                                    onClick={this.onViewClick}
                                >
                                    View
                                </button>
                                {list.length > 0 ?
                                    <button className="btn btn-aqua p-1 ml-3"
                                        disabled={!this.getDownloadAccess()}
                                        style={{ width: 140, fontSize: 15 }}
                                        onClick={() => this.downloadExcel()}
                                    >
                                        download
                                    </button>
                                    : <button className="btn btn-aqua p-1" style={{ width: 140, fontSize: 15 }} disabled={true}>
                                        download
                                    </button>
                                }
                            </div>
                        </div>
                        {console.log('xlrowArrxlrowArr', xlrowArr, 'columnArrcolumnArr', columnArr)}
                        {showTable && this.renderTable()}
                    </div>
                </div>
            </>
        )
    }
}

export default withRouter(connect(null, { fill_action, getExhibitorDetailsReport_action, getReceiptReport_action, getTaxInvoiceReport_action, getExhibitorFinalRankReport_action })(subReport1))